const sendLogin = (code) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
  'event': 'login',
  'userId': code
  })
}

const setUser = (code) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'userId': code
  })
}

export default {
  sendLogin,
  setUser
}
